<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/C4OLVK/images/cover.jpg?1684514595750" alt="This image is the cover for the book Enamorarse, Falling and When Memory Fails"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Enamorarse, Falling and When Memory Fails
      </h1>
      <p class="bookDescription body article font2">
        <p>Cuando Scott Allan recibe una llamada telefónica comunicándole que su hermano ha resultado herido en el trabajo, marcha corriendo al lado de Brian para encontrarse con que sus heridas son leves. Allí conoce a Hank Ballam, un leñador al que le gusta el riesgo, y que es marginado por sus propios compañeros de trabajo.</p> <p>Hank es una persona llena de contrastes: por un lado vive por la excitación que conlleva subir a los árboles y cortarlos, y por otro, le encanta la paz que se encuentra explorando las montañas que considera su casa. La atracción que Scott siente por Hank es inmediata y sorprendente, y es lo que siempre había soñado: saber qué se siente al amar a alguien sin el que no puedes vivir.</p> <p>Scott necesita conocer los verdaderos sentimientos de Hank, saber si se trata de un estallido de pasión o simplemente de una tranquila amistad, algo que no coincidiría con las emociones de Scott. Pero puede que ya sea demasiado tarde… porque Scott, sencillamente, no puede evitar enamorarse perdidamente de Hank.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        D.W. Marchwell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ea419a8